import gql from 'graphql-tag'

export const GET_ORGANIZATION_MEMBERSHIP_PLANS_AND_ORDER_ITEM_TEMPLATES = gql`
  query GetOrganizationMembershipPlans($organizationSlug: String!, $includeArchived: Boolean) {
    getOrganizationMembershipPlans(organizationSlug: $organizationSlug) {
      id
      name
      from
      to
      price
      amount
      description
      orderItemTemplates {
        id
        name
        price
        currency
      }
    }
    getOrganizationOrderItemTemplates(
      organizationSlug: $organizationSlug
      includeArchived: $includeArchived
    ) {
      id
      name
      membership
      archivedAt
    }
  }
`

export const GET_ORGANIZATION_MEMBERSHIP_PLANS = gql`
  query GetOrganizationMembershipPlans($organizationSlug: String!) {
    getOrganizationMembershipPlans(organizationSlug: $organizationSlug) {
      id
      name
      from
      to
      price
      amount
      description
      orderItemTemplates {
        id
        name
        price
        currency
      }
    }
  }
`

export const GET_SPORT_ORGANIZATION_MEMBERSHIP_PLANS = gql`
  query GetOrganizationMembershipPlans($organizationSlug: String!) {
    getOrganizationMembershipPlans(organizationSlug: $organizationSlug) {
      id
      name
      from
      to
      price
      amount
      description
      orderItemTemplates {
        id
        name
        price
        currency
      }
    }

    getOrganizationBySlug(organizationSlug: $organizationSlug) {
      id
      imageUrls
    }
  }
`

export const CREATE_MEMBERSHIP_PLAN = gql`
  mutation CreateMembershipPlan(
    $organizationSlug: String!
    $membershipPlanInput: MembershipPlanInput!
    $orderItemTemplates: [Int!]!
  ) {
    createMembershipPlan(
      organizationSlug: $organizationSlug
      membershipPlanInput: $membershipPlanInput
      orderItemTemplates: $orderItemTemplates
    )
  }
`
export const UPDATE_MEMBERSHIP_PLAN = gql`
  mutation UpdateMembershipPlan(
    $organizationSlug: String!
    $membershipPlanInput: MembershipPlanInput!
    $orderItemTemplates: [Int!]!
    $membershipPlanId: ID!
  ) {
    updateMembershipPlan(
      organizationSlug: $organizationSlug
      orderItemTemplates: $orderItemTemplates
      membershipPlanInput: $membershipPlanInput
      membershipPlanId: $membershipPlanId
    )
  }
`

export const UPDATE_SPORT_ORGANIZATION_MEMBERSHIP_PLAN = gql`
  mutation UpdateSportOrganizationMembershipPlan(
    $organizationSlug: String!
    $membershipPlanInput: MembershipPlanInput!
    $membershipPlanId: ID!
  ) {
    updateSportOrganizationMembershipPlan(
      organizationSlug: $organizationSlug
      membershipPlanInput: $membershipPlanInput
      membershipPlanId: $membershipPlanId
    )
  }
`
export const DELETE_MEMBERSHIP_PLAN = gql`
  mutation DeleteMembershipPlan($organizationSlug: String!, $membershipPlanId: ID!) {
    deleteMembershipPlan(organizationSlug: $organizationSlug, membershipPlanId: $membershipPlanId)
  }
`
